import PagePlaceholder from "@/components/page-placeholder"
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import PhysicalRiskEditModal from "@/entities/physical-risk/ui/modal/PhysicalRiskEditModal"
import PopulationDeleteModal from "@/entities/population/ui/modal/PopulationDeleteModal"
import PopulationEditModal from "@/entities/population/ui/modal/PopulationEditModal"
import populationStore from "@/entities/population/model/population.store"
import PopulationOverview from "@/entities/population/ui/PopulationOverview"
import PopulationsFilterPanel from "@/entities/population/ui/PopulationsFilterPanel"
import { faPencilAlt, faPlus, faTrashAlt } from "@fortawesome/free-solid-svg-icons"
import { useLayoutEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import NavEstablishment from "@/nav/nav.establishment"
import { useRisksSpace } from "@/core/risks-space.context"

export default function RisksPopulationRoute() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { getPath } = useRisksSpace()
  const { populationId } = useParams()
  const populations = useAppSelector(populationStore.selectors.list)
  const activePopulation = useAppSelector(populationStore.selectors.active)
  const isPopulationActive = useAppSelector(populationStore.selectors.isActive)
  const [modal, setModal] = useState<null | "EDIT" | "DELETE" | "ADD_RISK">(null)

  useLayoutEffect(() => {
    const population = populations.find((item) => item.id === populationId)
    dispatch(populationStore.actions.setActive(population ?? null))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, populationId])

  return (
    <NavEstablishment
      actions={[
        {
          id: "EDIT_POPULATION",
          icon: faPencilAlt,
          label: "Modifier la fonction",
          onClick: () => setModal("EDIT")
        },
        {
          id: "DELETE_POPULATION",
          icon: faTrashAlt,
          label: "Supprimer la fonction",
          onClick: () => setModal("DELETE")
        },
        {
          id: "ADD_RISK",
          icon: faPlus,
          label: "Ajouter risque",
          className: "primary",
          isLarge: true,
          onClick: () => setModal("ADD_RISK")
        }
      ]}
      onTabClick={() => dispatch(populationStore.actions.setActive(null))}>
      {modal === "EDIT" && <PopulationEditModal onClose={() => setModal(null)} />}
      {modal === "DELETE" && <PopulationDeleteModal onClose={() => setModal(null)} />}
      {modal === "ADD_RISK" && isPopulationActive && (
        <PhysicalRiskEditModal
          onClose={() => setModal(null)}
          context={{ type: "population", population: activePopulation }}
        />
      )}

      <div className="flex fixed top-[48px] left-0 h-[calc(100%-48px)] app-content-width">
        <div className="flex-1 min-w-0">
          {isPopulationActive ? (
            <PopulationOverview />
          ) : (
            <PagePlaceholder
              title="Fonction introuvable"
              button="Retour aux fonctions"
              onClick={() => navigate(getPath("/populations"))}
            />
          )}
        </div>
        <PopulationsFilterPanel />
      </div>
    </NavEstablishment>
  )
}
